import { render, staticRenderFns } from "./ContentTypeAboutMe.vue?vue&type=template&id=eb117bc0&scoped=true&"
import script from "./ContentTypeAboutMe.vue?vue&type=script&lang=js&"
export * from "./ContentTypeAboutMe.vue?vue&type=script&lang=js&"
import style0 from "./ContentTypeAboutMe.vue?vue&type=style&index=0&id=eb117bc0&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb117bc0",
  null
  
)

export default component.exports